import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Center,
  FormControl,
  FormHelperText,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import TradingSpinner from "../TradingSpinner";

const AccountValueOptInDialog = ({
  isOpen,
  cancelRef,
  authLoading,
  preferences,
  hasPreferences,
  accountvalue,
  onAccountValueChange,
  format,
  parse,
  onCancel,
  onConfirm,
}) => (
  <AlertDialog
    motionPreset="slideInBottom"
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onCancel}
    isCentered={true}
    closeOnOverlayClick={false}
  >
    {authLoading && isOpen ? (
      <AlertDialogOverlay>
        <AlertDialogContent>
          <Center p={6}>
            <TradingSpinner size="40px" />
          </Center>
        </AlertDialogContent>
      </AlertDialogOverlay>
    ) : (
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {hasPreferences && preferences.account_value_optin === 0
              ? "Set Account Value"
              : "Update Account Value"}
          </AlertDialogHeader>
          <AlertDialogBody>
            <FormControl>
              <FormHelperText mb={2} ml={1}>
                Current Account Value
              </FormHelperText>
              <NumberInput
                onChange={(valueString) =>
                  onAccountValueChange(parse(valueString))
                }
                value={format(accountvalue, preferences.preferred_currency)}
                min={0}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onCancel} borderRadius="md">
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={onConfirm}
              ml={3}
              borderRadius="md"
            >
              Submit
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    )}
  </AlertDialog>
);

export default AccountValueOptInDialog;
